import React from "react";

function trackEvent(action, label) {
  if (window.gtag) {
    window.gtag("event", action, {
      event_category: "Navigation",
      event_label: label,
    });
  }
}

function Header() {
  return (
    <header className="header" role="banner">
      <h1 className="logo" id="logo"><a href="/" onClick={() => trackEvent("root_click", "Sukun Cloud Consulting")}>Sukun Cloud Consulting</a></h1>
      <nav role="navigation" aria-label="Main Navigation">
        <a href="/about" onClick={() => trackEvent("tab_click", "About Us")}>
          About Us
        </a>
        <a href="/services" onClick={() => trackEvent("tab_click", "Our Services")}>
          Our Services
        </a>
        <a href="/case-studies" onClick={() => trackEvent("tab_click", "Case Studies")}>
          Case Studies
        </a>
        {/* <a href="/interactive-guide" onClick={() => trackEvent("tab_click", "Interactive Guide")}>
          Interactive Guide
        </a> */}
        <a href="/why-us" onClick={() => trackEvent("tab_click", "Why Choose Us")}>
          Why Choose Us
        </a>
        <a href="/contact" onClick={() => trackEvent("tab_click", "Get in Touch")}>
          Get in Touch
        </a>
      </nav>
    </header>
  );
}

export default Header;